import { render, staticRenderFns } from "./MinuteEditorTab.vue?vue&type=template&id=66366bc8&scoped=true"
import script from "./MinuteEditorTab.vue?vue&type=script&lang=js"
export * from "./MinuteEditorTab.vue?vue&type=script&lang=js"
import style0 from "./MinuteEditorTab.vue?vue&type=style&index=0&id=66366bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66366bc8",
  null
  
)

export default component.exports